export const ADD_ITEM = 'cart/addItem';
export const SET_ITEM = 'cart/setItem';
export const REMOVE_ITEM = 'cart/removeItem';
export const CLEAR_ITEMS = 'cart/clearItems';
export const SET_SHIPPING = 'cart/setShipping';
